import { useRef, useCallback } from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeModalProps {
  url: string;
  title: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function QRCodeModal({ url, title, isOpen, onClose }: QRCodeModalProps): React.ReactElement {
  const qrRef = useRef<HTMLDivElement>(null);

  const handleCopyLink = useCallback((): void => {
    navigator.clipboard.writeText(url);
  }, [url]);

  const handleDownloadQR = useCallback((): void => {
    const svgElement = qrRef.current?.querySelector('svg');
    if (!svgElement) return;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const svgUrl = URL.createObjectURL(svgBlob);

    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      URL.revokeObjectURL(svgUrl);

      const pngUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = `qr-${title.replace(/\s+/g, '-').toLowerCase()}.png`;
      link.href = pngUrl;
      link.click();
    };
    img.src = svgUrl;
  }, [title]);

  return (
    <dialog className={`modal ${isOpen ? 'modal-open' : ''}`}>
      <div className="modal-box max-w-sm text-center">
        <button
          onClick={onClose}
          className="btn btn-circle btn-sm btn-ghost absolute top-2 right-2"
        >
          &#10005;
        </button>

        <h3 className="font-bold text-lg mb-4">{title}</h3>

        <div ref={qrRef} className="flex justify-center mb-4">
          <QRCodeSVG value={url} size={220} level="H" includeMargin />
        </div>

        <p className="text-sm text-base-content/60 break-all mb-4">{url}</p>

        <div className="flex gap-2 justify-center">
          <button className="btn btn-outline btn-sm" onClick={handleCopyLink}>
            Copiar enlace
          </button>
          <button className="btn btn-primary btn-sm" onClick={handleDownloadQR}>
            Descargar QR
          </button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button onClick={onClose}>close</button>
      </form>
    </dialog>
  );
}
